/**
 * Auth context provider for multi-tenant mode.
 *
 * Wraps useAuth hook and provides auth state + actions to the
 * component tree. Only active when MULTI_TENANT=true.
 */

import { createContext, useContext, type ReactNode } from 'react';
import { useAuth, type AuthState, type AuthActions } from '@/hooks/connection/useAuth';

type AuthContextValue = AuthState & AuthActions;

const AuthContext = createContext<AuthContextValue | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const auth = useAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}
